import { ActionTree } from 'vuex'
import * as types from './mutation-types'
import RootState from '@vue-storefront/core/types/RootState'
import AppleState from '../../types/AppleState'
import { buildApiUrl } from '../../helpers'
import fetch from 'isomorphic-fetch'
import config from 'config'

const actions: ActionTree<AppleState, RootState> = {
  async validateApplePaySession ({ commit }, payload) {
    return await fetch(buildApiUrl(config.ipay.applepay.api.validate_session, payload), {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => resp.json())
      .catch(err => console.error(err))
  },
}

export default actions
